import React from 'react';
import { useSelector } from 'react-redux';

import Files from '../files';
import { isConsentFlagActive } from '@wetransfer/transfer/component/consent-manager';
import { selectIsValidTCString } from '@wetransfer/transfer/store/selector/consent';
import {
  selectFileIdParam,
  selectRecipientIdParam,
  selectRoute,
  selectTransferSecretParam,
} from '@wetransfer/transfer/store/selector/route';
import {
  selectIsSessionTandC,
  selectSession,
} from '@wetransfer/transfer/store/selector/session';
import {
  selectTransfer,
  selectTransferId,
} from '@wetransfer/transfer/store/selector/transfer';
import { getCurrentSize } from '@wetransfer/transfer/transfer-bundle/store/selectors';

import { FilesContainerProps } from './types';

export default function FilesContainer({
  isReady,
}: FilesContainerProps): JSX.Element {
  const transfer = useSelector(selectTransfer);
  const secret = useSelector(selectTransferSecretParam);
  const id = useSelector(selectTransferId) || undefined;
  const fileIdParam = useSelector(selectFileIdParam);
  const route = useSelector(selectRoute);
  const acceptedTandC = useSelector(selectIsSessionTandC);
  const isConsentStringValid = useSelector(selectIsValidTCString);
  const session = useSelector(selectSession);
  const currentSize = useSelector(getCurrentSize);
  const recipientId = useSelector(selectRecipientIdParam);

  return (
    <Files
      acceptedTandC={acceptedTandC}
      currentSize={currentSize}
      file_id={fileIdParam}
      id={id}
      isConsentFlagActive={isConsentFlagActive()}
      isConsentStringValid={isConsentStringValid}
      isReady={isReady}
      recipient={recipientId}
      route={route}
      secret={secret}
      session={session}
      transfer={transfer}
    />
  );
}
